var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ed-presentation-mode-webview-options"},[_c('ed-nav-meetings-tools',{staticClass:"ed-nav-meetings-tools"}),_c('ed-nav-meetings-mobile',{staticClass:"ed-nav-meeting-mobile"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }